import React, { createContext, useContext } from 'react';

const ShellContentAreaContext = createContext(false);

export const useIsInShellContentArea = (): boolean =>
  useContext(ShellContentAreaContext);

export const ShellContentAreaProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <ShellContentAreaContext.Provider value>
    {children}
  </ShellContentAreaContext.Provider>
);

export default ShellContentAreaContext;
